document.addEventListener('change', function(e) {
  if (!e.target.matches('[data-variant-input]')) return;

  const container = e.target.closest('[data-section-id]');
  if (!container) return;

  const selects = container.querySelectorAll('[data-variant-input]');

  const optionValueIds = [];
  let productUrl = null;

  selects.forEach(select => {
    const selectedOption = select.options[select.selectedIndex];

    const optionValueId = selectedOption.dataset.optionValueId;
    if (optionValueId) {
      optionValueIds.push(optionValueId);
    }

    const optionProductUrl = selectedOption.dataset.productUrl;
    if (optionProductUrl && optionProductUrl !== window.location.pathname) {
      productUrl = optionProductUrl;
    }
  });

  const optionValuesParam = optionValueIds.join(',');

  // Combined listing support
  if (productUrl) {
    window.location.href = `${productUrl}?option_values=${optionValuesParam}`;
    return;
  }

  // High variant support (AJAX render)
  const sectionId = container.dataset.sectionId;

  const url = `${window.location.pathname}?section_id=${sectionId}&option_values=${optionValuesParam}`;

  fetch(url)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newSection = doc.querySelector(`[data-section-id="${sectionId}"]`);
      const currentSection = document.querySelector(`[data-section-id="${sectionId}"]`);

      if (newSection && currentSection) {
        currentSection.innerHTML = newSection.innerHTML;
      }

      // update URL without reload
      history.replaceState(null, '', `?option_values=${optionValuesParam}`);
    })
    .catch(err => console.error('Variant update failed:', err));
});